import { Fragment, useEffect, useMemo, useState } from 'react';
import { Page } from '../theme/elements/Page';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { isLoading, getError, setError } from 'state/reducers/pending-requests.reducer';
import { selectTranslations } from 'state/reducers/translation.reducers';
import {
	selectFlattenedCategoryOptions,
	getPaymentCategoriesTranslationsMap,
	getPaymentCategories as getPaymentCategoriesSelector,
} from 'state/reducers/payment-categories.reducer';
import {
	approveFeature,
	getAvailablePaymentDates,
	getFeature,
} from 'services/pending-requests.service';
import { getPaymentCategories, fetchPaymentCategoryTranslations } from 'services/payment-categories.service';
import _ from 'lodash';
import { useParams, useNavigate } from 'react-router-dom';
import { FormCard, FormCardSingleColumnLayout } from 'theme/elements/Forms';
import FormCreatorComponent, { isValidForm } from 'components/FormCreatorComponent';
import { pendingRequestsTypesForms } from 'sections/pendingRequests/forms.types';
import {
	getCompanyFeatureApprovePayload,
	getFeaturePayload,
	getFormsValuesByType,
	getOptionsDependenciesByItemForApprove,
	getCustomDependenciesByItemForApprove,
	getInitialApproveFormValues,
	isAllowSubmitForApprove,
	isFormNeedsHidingInApprove,
} from 'sections/pendingRequests/helper';
import {
	RequestsTypesNeedCompanyData,
	RequestsTypesNeedDialog,
	pendingRequestsTypes,
} from 'constants/requests.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';
import { ApproveDialogButtons, ApproveFormButtons } from 'components/FormElementsComponent/FormActionsButtons';
import { fieldType } from 'components/FormCreatorComponent/types';
import {
	mapingFeature,
	mapingFeatureToEndpoint,
	additionalMappingFeature,
} from 'constants/pending-requests.constants';
import { pagesEnum } from 'constants/ui.constants';
import { getUserDetails } from 'state/reducers/user.reducers';
import { WarningDialog } from 'components/WarningDialog';
import { getCustomDependenciesForApprove, getOptionsDependenciesForApprove } from 'state/reducers/global.reducer';
import {
	ApproveRequestDialog,
	CancelRequestDialog,
	RejectRequestDialog,
} from 'sections/pendingRequests/PendingRequestsDialogs';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { useDuplicateBalanceCheckOnLoad } from 'sections/pendingRequests/hooks/useDuplicateBalanceCheckOnLoad';
import { getCompanies } from 'state/reducers/global.reducer';
import { getCompanyNameByLanguage } from 'utils/index';
import { customerAccountDetailsTypes, moneyActivityTypes } from 'constants/customer-account.constants';
import { setSuccessMessage } from 'state/reducers/ui.reducers';
import { getCustomerDashboard } from 'services/customer-accounts.service';
import { getCompanyDashboard } from 'state/reducers/customer-accounts.reducers';
import { getPagesByFeature } from 'services/content.service';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { applyDueDateStyling } from '../sections/pendingRequests/helper';
import PaymentCategoriesView from 'components/PaymentCategoriesView';
export const CompanyFeatureApproveApp = () => {
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const loading = useAppSelector(isLoading);
	const navigate = useNavigate();
	const [item, setItem] = useState<Record<string, any>>();
	const [formState, setFormState] = useState<Record<string, any>>({});
	const searchPermission = hasPermission([permissionEnums.APPROVE_BENEFICIARY]);
	const [openApproveDialog, setOpenApproveDialog] = useState(false);
	const [openRejectDialog, setOpenRejectDialog] = useState(false);
	const [openCancelDialog, setOpenCancelDialog] = useState(false);
	const [BoNotes, setBoNotes] = useState<string | null>(null);
	const [availablePaymentDates, setAvailablePaymentDates] = useState<string[]>([]);
	const { type = '', id } = useParams();
	const { permissions } = useAppSelector(getUserDetails);
	const companies = useAppSelector(getCompanies);
	const [customDependencies, setCustomDependencies] = useState<Record<string, any>>({});
	const OptionsDependenciesForApprove = useAppSelector(
		getOptionsDependenciesForApprove(type as pendingRequestsTypes, item)
	);
	const [isSaving, setIsSaving] = useState(false);
	const [rejectTemplate, setRejectTemplate] = useState('regular');
	const companyData = useAppSelector(getCompanyDashboard);
	const { dialogConfig: duplicateDialogConfig, handleConfirm: handleDuplicateConfirm, handleCancel: handleDuplicateCancel } =
		useDuplicateBalanceCheckOnLoad(item, type, id);

	const proceedToApprove = () => {
		if (RequestsTypesNeedDialog.includes(type as pendingRequestsTypes)) {
			setOpenApproveDialog(true);
		} else {
			handleApprove('approve');
		}
	};

	const handleReject = (specialReject?: boolean) => {
		switch (type) {
			case pendingRequestsTypes.BENEFICIARIES:
				setRejectTemplate(specialReject ? 'beneficiaryRejectForFix' : 'beneficiaryReject');
				break;
			case pendingRequestsTypes.GENERAL_SUPPORT:
				setRejectTemplate('generalSupport');
		}

		if (RequestsTypesNeedDialog.includes(type as pendingRequestsTypes)) {
			setOpenRejectDialog(true);
		} else {
			handleApprove('reject');
		}
	};

	const handleApprove = (action: string) => {
		if (id && type) {
			let values = formValues;
			_.values(formState).forEach(
				(prop) =>
					(values =
						prop?.dirtyFields && !_.isEmpty(prop.dirtyFields) ? { ...values, ...prop.dirtyFields } : values)
			);

			const props: any = getCompanyFeatureApprovePayload(action, type, id, BoNotes, { ...formValues, ...values });
			/*if (BoNotes) {
        props.data['boNotes'] = _.isNil(BoNotes) ? '' : BoNotes;
      }*/
			if (props.name !== '') {
				setIsSaving(true);
				dispatch(approveFeature(props))
					.unwrap()
					.then((originalPromiseResult) => {
						setIsSaving(false);
						if (originalPromiseResult?.success) {
							/*if (_.isEqual(type, pendingRequestsTypes.BENEFICIARIES)) {
                return navigate(
                  `/${pagesEnum.CUSTOMER_ACCOUNTS_DETAILS}/${item?.companyId}/${customerAccountDetailsTypes.BENEFICIARIES}/${id}`
                );
              }*/
							dispatch(setSuccessMessage(true));
							navigate(-1);
						}
					})
					.catch((rejectedValueOrSerializedError) => {
						// handle error here
						setIsSaving(false);
						console.log(rejectedValueOrSerializedError);
					});
			}
		}
	};

	useEffect(() => {
		if (type === pendingRequestsTypes.PAYMENTS && item?.currencyId && item?.dueDate) {
			const today = format(new Date(), 'yyyy-MM-dd');

			dispatch(getAvailablePaymentDates(item.currencyId, today)).then((res: any) => {
				const dates = res?.data?.validPaymentDates || [];
				if (dates.length > 0) {
					setAvailablePaymentDates(dates);
				}
			});
		}
	}, [type, item?.currencyId, item?.dueDate]);

	const optionsDependencies = useMemo(() => {
		return {
			...OptionsDependenciesForApprove,
			...getOptionsDependenciesByItemForApprove(type as pendingRequestsTypes, item),
		};
	}, [companyData, OptionsDependenciesForApprove]);

	const customDependenciesGlobalData =
		useAppSelector(getCustomDependenciesForApprove(type as pendingRequestsTypes)) || {};

	// Get payment categories and translations for display - needed to recompute formValues when they load
	const paymentCategories = useAppSelector(getPaymentCategoriesSelector);
	const paymentCategoriesTranslations = useAppSelector(getPaymentCategoriesTranslationsMap);

	const formValues = useMemo(() => {
		const props = getFeaturePayload(type || '', id || '');
		if (!item) {
			if (props.name !== '') {
				dispatch(getFeature(props))
					.unwrap()
					.then((originalPromiseResult) => {
						let _item = _.get(originalPromiseResult, _.get(mapingFeature, type || ''));
						if (_item) {
							if (additionalMappingFeature[type]) {
								_item = {
									..._item,
									[additionalMappingFeature[type]]: _.get(
										originalPromiseResult,
										additionalMappingFeature[type]
									),
								};
							}

							if (type === pendingRequestsTypes.BENEFICIARIES) {
								_item = {
									..._item,
									wcAudit: originalPromiseResult.wcAudit,
								};
							}

							if (customDependenciesGlobalData) {
								setCustomDependencies(
									getCustomDependenciesByItemForApprove(
										type as pendingRequestsTypes,
										_item,
										customDependenciesGlobalData
									)
								);
							}
							setItem({ ..._item, ...getInitialApproveFormValues(_item, type) });
						}
					})
					.catch((rejectedValueOrSerializedError) => {
						// handle error here
						console.log(rejectedValueOrSerializedError);
					});
			}
		} else {
			try {
				if (item) {
					//get companyData
					if (RequestsTypesNeedCompanyData.includes(type as pendingRequestsTypes)) {
						dispatch(getCustomerDashboard(Number(item?.companyId || item?.requestedByCompanyId)));
					}

					const pickFormValues = getFormsValuesByType(item, type);
					return pickFormValues as any;
				}
			} catch (e) {
				console.log(e);
				return undefined;
			}
		}
		return undefined;
	}, [item, paymentCategories, paymentCategoriesTranslations]);

	useEffect(() => {
		if (customDependenciesGlobalData && item && !customDependencies) {
			setCustomDependencies(
				getCustomDependenciesByItemForApprove(type as pendingRequestsTypes, item, customDependenciesGlobalData)
			);
		}
	}, [customDependenciesGlobalData, customDependencies]);

	const getDynamicFieldAttr = (fieldName: string) => {
		try {
			if (item) {
				switch (type) {
					case pendingRequestsTypes.BENEFICIARIES:
						if (_.isArray(item.beneficiaryDeniedMessages) && item.beneficiaryDeniedMessages.length) {
							const last = _.last(item.beneficiaryDeniedMessages);
							if (!_.isNil(last.dirtyFields)) {
								const list = last.dirtyFields.split(',');
								if (list.includes(fieldName)) {
									return {
										styleObj: {
											border: '1px solid blue',
											borderRadius: '10px',
										},
									};
								}
							}
						}
						break;
				}
			}
		} catch (e) {}
		return {};
	};

	const companyName = useMemo(() => {
		if (item && companies) {
			const company = _.find(companies, { id: item.companyId || item.requested_by_company_id });
			return getCompanyNameByLanguage(company) || '';
		}
		return '';
	}, [item, companies]);

	const forms = useMemo(() => {
		if (formValues && type && _.has(pendingRequestsTypesForms, type)) {
			const _forms = _.get(pendingRequestsTypesForms, type as string);
			const formsToShow = _.filter(_forms, (form) => !form.hide && !isFormNeedsHidingInApprove(form, type, item));
			const k = _.map(formsToShow, (form) => ({
				...form,
				fieldsGroups: _.map(form.fieldsGroups, (group) => ({
					...group,
					fields: applyDueDateStyling(
						_.map(group.fields, (field) => ({
							...field,
							...getDynamicFieldAttr(field?.props?.name || ''),
							props: {
								...field.props,
								options:
									_.isEqual(field.type, fieldType.select) &&
									_.has(optionsDependencies, field.props.name)
										? _.get(optionsDependencies, field.props.name)
										: field.props?.options || [],
								customData:
									_.isEqual(field.type, fieldType.custom) &&
									_.has(customDependencies, field.props.name)
										? _.get(customDependencies, field.props.name)
										: field.props?.customData || [],
							},
						})),
						formValues,
						t,
						availablePaymentDates
					),
				})),
			}));
			return k;
		}
		return undefined;
	}, [formValues, optionsDependencies, customDependencies]);

	useEffect(() => {
		if (formValues) {
			const typeForms = _.get(pendingRequestsTypesForms, type as string);
			let formsState: Record<string, any> = {};
			typeForms.forEach((form) => {
				const dirtyValues =
					_.has(formState, form.name) && _.has(formState[form.name], 'dirtyFields')
						? _.get(formState[form.name], 'dirtyFields')
						: {};
				formsState = {
					...formsState,
					[form.name]: isValidForm(form.fieldsGroups, { ...formValues, ...dirtyValues }, true),
				};
			});
			setFormState(formsState);
		}
	}, [formValues]);

	const hasApprovePermission = useMemo(() => {
		if (item && !isAllowSubmitForApprove(type as pendingRequestsTypes, item)) {
			return false;
		}
		if (permissions.permissions) {
			const permission = 'approve_' + _.get(mapingFeatureToEndpoint, type || '');
			return permissions.permissions.includes(permission);
		}
	}, [permissions, item]);

	useEffect(() => {
		if (permissions.permissions) {
			const permission = 'read_' + _.get(mapingFeatureToEndpoint, type || '');
			if (!permissions.permissions.includes(permission)) {
				navigate('/' + pagesEnum.PAGE_NOT_FOUND);
			} else {
				dispatch(getPagesByFeature('open system ui', 'beneficiary'));
			}
		}
	}, [permissions]);

	// Fetch payment categories data for PaymentCategoriesView
	const paymentCategoryOptions = useAppSelector(selectFlattenedCategoryOptions);
	const paymentCategoriesTranslationsMap = useAppSelector(getPaymentCategoriesTranslationsMap);

	useEffect(() => {
		if (paymentCategoryOptions.length === 0) {
			dispatch(getPaymentCategories() as any);
		}
		if (Object.keys(paymentCategoriesTranslationsMap).length === 0) {
			dispatch(fetchPaymentCategoryTranslations() as any);
		}
	}, [dispatch, paymentCategoryOptions.length, paymentCategoriesTranslationsMap]);

	const formatDateForComments = (dateString: string): string => {
		const date = new Date(dateString);
		const formattedDate = format(date, 'dd.MM.yyyy');
		const time = format(date, 'HH:mm');

		const writtenAt = t('page.newAccount.tables.writtenAt');
		const atHour = t('page.newAccount.tables.atHour');

		return `${writtenAt} - ${formattedDate} ${atHour} ${time}`;
	};

	return (
		<Fragment>
			<Page
				includeGoBack
				title={`${t('page.pendingRequests.table.' + type + '.title')} - ${companyName}`}
				subTitle={(item && item?.reference) || ''}
				loading={isSaving}
			>
				<FormCardSingleColumnLayout>
					<>
						{forms &&
							forms.map((form, index: number) => {
								return (
									<FormCard key={index} title={t(form.name)}>
										<FormCreatorComponent
											{...form}
											translation={t}
											values={formValues}
											checkInitValidation={false}
											handleChange={(newformState: Record<string, any>) => {
												setFormState({ ...formState, [form.name]: newformState });
											}}
										/>
									</FormCard>
								);
							})}
						{type === pendingRequestsTypes.BENEFICIARIES && item?.allowedPaymentCategoryIds?.length > 0 && (
							<PaymentCategoriesView categoryIds={item?.allowedPaymentCategoryIds} />
						)}
					</>
					<>
						{type === pendingRequestsTypes.BENEFICIARIES &&
							formValues?.beneficiaryDeniedMessages &&
							formValues?.beneficiaryDeniedMessages.length !== 0 && (
								<>
									<Box display="flex" alignItems="center" gap={1}>
										<Avatar src="/icons/warning-orange.svg" sx={{ width: 18, height: 18 }} />
										<Typography variant="h6" sx={{ marginBottom: 0 }}>
											{t('page.customerAccounts.forms.beneficiaries.deniedMessages.title')}
										</Typography>
									</Box>

									{_.orderBy(formValues?.beneficiaryDeniedMessages, ['createdAt'], ['desc'])?.map(
										(beneficiaryDeniedMessage: any, index: number) => {
											return (
												beneficiaryDeniedMessage?.message && (
													<Stack
														gap={1}
														key={index}
														sx={{
															backgroundColor: '#F4FAF8',
															padding: '10px',
														}}
													>
														{beneficiaryDeniedMessage?.createdByBoUser && (
															<Box display="flex" alignItems="center" gap={1}>
																<img
																	src={'/icons/altshuler.svg'}
																	width={25}
																	alt="User Icon"
																/>
																<Typography variant="boldBody7">
																	{`${t(
																		'page.customerAccounts.forms.beneficiaries.deniedMessages.agent'
																	)}: ${
																		beneficiaryDeniedMessage.createdByBoUser
																			?.firstName
																	} ${
																		beneficiaryDeniedMessage.createdByBoUser
																			?.lastName
																	}`}
																</Typography>
															</Box>
														)}

														{beneficiaryDeniedMessage?.createdByContact && (
															<Box display="flex" alignItems="center" gap={1}>
																<img src={'/icons/user-avatar.svg'} width={25} />
																<Typography variant="boldBody7">
																	{`${beneficiaryDeniedMessage.createdByContact?.firstName} ${beneficiaryDeniedMessage.createdByContact?.lastName}`}
																</Typography>
															</Box>
														)}

														<Typography variant="body1">
															{formatDateForComments(beneficiaryDeniedMessage.createdAt)}
														</Typography>
														<Typography variant="body1">
															{_.get(
																beneficiaryDeniedMessage,
																'translation[0].he',
																beneficiaryDeniedMessage.message
															)}
														</Typography>
													</Stack>
												)
											);
										}
									)}
								</>
							)}
					</>

					{hasApprovePermission && (
						<>
							{_.isEqual(type, pendingRequestsTypes.GENERAL_SUPPORT) ? (
								<ApproveDialogButtons
									approveLabel={'label.closeRequest'}
									handleApprove={handleReject}
									handleReject={() => navigate(-1)}
								/>
							) : (
								<ApproveFormButtons
									disabledApprove={!_.every(_.values(formState), { isValid: true }) || isSaving}
									loading={loading}
									cancelLabel={t('label.back')}
									handleDecline={_.isEqual(type, pendingRequestsTypes.BENEFICIARIES)}
									handleReject={handleReject}
									handleApprove={proceedToApprove}
									handleCancel={() => {
										if (_.some(_.values(formState), { isDirty: true })) {
											setOpenCancelDialog(true);
										} else {
											navigate(-1);
										}
									}}
								/>
							)}
						</>
					)}
				</FormCardSingleColumnLayout>
			</Page>
			<CancelRequestDialog
				openDialog={openCancelDialog}
				setOpenDialog={setOpenCancelDialog}
				type={type as string}
				BoNotes={BoNotes}
				setBoNotes={setBoNotes}
				handleApprove={() => {}}
			/>
			<ApproveRequestDialog
				openDialog={openApproveDialog}
				setOpenDialog={setOpenApproveDialog}
				type={type as string}
				BoNotes={BoNotes}
				setBoNotes={setBoNotes}
				handleApprove={handleApprove}
				hasWcIndications={formValues?.hasWcIndications === 'true'}
			/>
			<RejectRequestDialog
				openDialog={openRejectDialog}
				setOpenDialog={setOpenRejectDialog}
				type={type as string}
				template={rejectTemplate}
				BoNotes={BoNotes}
				setBoNotes={setBoNotes}
				handleApprove={handleApprove}
			/>
			<ConfirmationDialog
				open={duplicateDialogConfig.open}
				title={duplicateDialogConfig.title}
				content={duplicateDialogConfig.content}
				message={duplicateDialogConfig.message}
				confirmLabel={duplicateDialogConfig.confirmLabel}
				cancelLabel={duplicateDialogConfig.cancelLabel}
				disableBackdropClose={duplicateDialogConfig.disableBackdropClose}
				onConfirm={handleDuplicateConfirm}
				onCancel={handleDuplicateCancel}
				loading={duplicateDialogConfig.loading}
				error={duplicateDialogConfig.error}
				confirmColor="primary"
			/>
		</Fragment>
	);
};
